import { render, staticRenderFns } from "./AgreementsDetail.vue?vue&type=template&id=d330b9ce&scoped=true&"
import script from "./AgreementsDetail.vue?vue&type=script&lang=js&"
export * from "./AgreementsDetail.vue?vue&type=script&lang=js&"
import style0 from "./AgreementsDetail.vue?vue&type=style&index=0&id=d330b9ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d330b9ce",
  null
  
)

export default component.exports